/**
 * Piezas compartidas de las pantallas de envío masivo a los vecinos (informe
 * mensual, recordatorio semestral). Convención #19: una sola implementación
 * de lo que protege al vecino, para que las pantallas no diverjan.
 */
import type { ReactNode } from 'react';

/** El correo tal como lo manda el backend, en un iframe `srcDoc` +
 *  `sandbox=""`: sin scripts y sin mezclar su CSS claro con el tema oscuro
 *  del portal. Si la pantalla lo re-maquetara, el tesorero aprobaría algo
 *  distinto de lo que sale. */
export function VistaPreviaCorreo({
  asunto,
  html,
  nota,
}: {
  asunto: string;
  html: string;
  nota?: ReactNode;
}) {
  return (
    <>
      <p className="text-xs text-text-secondary mb-2">
        Asunto: <span className="font-mono">{asunto}</span>
      </p>
      {nota && <p className="text-xs text-text-secondary mb-2">{nota}</p>}
      <iframe
        title="Vista previa del correo"
        srcDoc={html}
        sandbox=""
        className="w-full rounded-md border-[0.5px] border-white/10 bg-white"
        style={{ height: 620 }}
      />
    </>
  );
}

/** Casas que quedan fuera del envío, desplegables: el número no puede quedar
 *  escondido detrás de un "enviado a N". */
export function CasasFuera({
  identificadores,
  resumen,
  advertencia = true,
}: {
  identificadores: string[];
  resumen: string;
  /** Color de advertencia (casas sin correo) o neutro (exclusión decidida). */
  advertencia?: boolean;
}) {
  if (identificadores.length === 0) return null;
  return (
    <details className="mt-2">
      <summary
        className={`text-sm cursor-pointer ${
          advertencia ? 'text-state-warning' : 'text-text-secondary'
        }`}
      >
        {resumen}
      </summary>
      <p className="text-xs text-text-secondary mt-1 font-mono">
        {identificadores.join(' · ')}
      </p>
    </details>
  );
}
